<app-sidebar-skeleton-loader *ngIf="isLoading" [isSlimMode]="isSlimMode"></app-sidebar-skeleton-loader>

<aside *ngIf="!isLoading" [ngClass]="{'w-20': isSlimMode, 'w-[250px]': !isSlimMode}"
  class="block bg-black dark:bg-dark-sidebar no-print shadow-sidebar transition-all duration-300"
  style="height: calc(100vh - 100px);">
  <div class="flex-1 overflow-auto p-4 flex flex-col justify-between h-full">

    <div *ngIf="currentUser && currentUser.sub" class="mb-0">
      <div
        [ngClass]="{'flex-col p-2 rounded-lg bg-gradient-to-br from-gray-800 to-gray-900 border border-gray-600 user-profile-section': !isSlimMode, 'justify-center items-center': isSlimMode}"
        class="flex w-full">
        <div class="flex items-center space-x-2 mb-2">
          <div class="relative cursor-pointer" (click)="toggleSlimMode()" title="Toggle sidebar mode">
            <app-profile-image [member]="currentUser" [config]="{size: 'h-[40px] w-[40px] text-[18px]' }"
              class="w-8"></app-profile-image>
          </div>
          <div *ngIf="!isSlimMode" class="flex flex-col flex-1 min-w-0">
            <div class="font-semibold text-[11px] text-white capitalize leading-tight">
              {{currentUser.name}} {{currentUser.lastName}}
            </div>
            <div class="text-[10px] text-gray-300 font-medium leading-tight">
              {{currentUser.email}}
            </div>
          </div>
        </div>
        <div *ngIf="!isSlimMode" class="flex items-center justify-between pt-1 border-t border-gray-700">
          <div class="flex items-center space-x-1" *ngIf="!missingOrganization">
            <div class="w-1 h-1 bg-gray-500 rounded-full"></div>
            <span class="text-[10px] text-gray-300 font-medium">{{currentUser.role | titlecase}}</span>
          </div>
          @if(!missingOrganization){
          <div class="text-[10px] text-gray-300 font-medium truncate max-w-[130px]">
            {{currentUser.organization || 'missing organization'}}
          </div>
          }@else {
          <div class="flex items-start space-x-1 text-center">
            <div class="text-[9px] text-gray-300 font-medium">
              The organization has not been configured
            </div>
          </div>
          }
        </div>
      </div>
    </div>


    <nav class="flex flex-col text-lg w-full h-full justify-between my-6">
      <div class="space-y-2">
        <div class="mb-2">
          <div class="sidebar-header">
            <span class="header-text">Features</span>
          </div>
          <div class="header-divider"></div>
        </div>

        <a class="sidebar-item" [routerLink]="['/']"
          [ngClass]="{'active': isActive('/'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, 'Home')" (mouseleave)="hideSlimFlyout()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-white">
            <path fill-rule="evenodd"
              d="M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z"
              clip-rule="evenodd" />
          </svg>
          <div *ngIf="!isSlimMode" class="sidebar-text">Home</div>
        </a>


        <a *ngIf="boardsEnabled" class="sidebar-item" [routerLink]="['/boards']" id="sidebar-boards-link"
          [ngClass]="{'active': isActive('/boards'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, 'Boards')" (mouseleave)="hideSlimFlyout()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
            <path
              d="M14 17h2.75A2.25 2.25 0 0 0 19 14.75v-9.5A2.25 2.25 0 0 0 16.75 3H14v14ZM12.5 3h-5v14h5V3ZM3.25 3H6v14H3.25A2.25 2.25 0 0 1 1 14.75v-9.5A2.25 2.25 0 0 1 3.25 3Z" />
          </svg>
          <div *ngIf="!isSlimMode" class="sidebar-text">Boards</div>
        </a>

        <a class="sidebar-item" [routerLink]="['/calendar']" id="sidebar-calendar-link"
          [ngClass]="{'active': isActive('/calendar'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, 'Congress Calendar')" (mouseleave)="hideSlimFlyout()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
          </svg>

          <div *ngIf="!isSlimMode" class="sidebar-text">Congress Calendar</div>
        </a>
        @if(!missingOrganization){
        @for (nav of navigation; track nav.uuid) {
        <div class="space-y-4 w-full text-center items-center mb-2">
          <a *ngIf="nav.uuid" class="sidebar-item cursor-pointer" [ngClass]="{
                      active: isActiveReport(nav.uuid),
                      'flex items-center space-x-2': !isSlimMode,
                      icon: isSlimMode
                    }" (click)="onReportClick(nav)" (mouseenter)="showSlimFlyout($event, nav.menuName)"
            (mouseleave)="hideSlimFlyout()">
            <lucide-icon [name]="nav.iconName" class="text-white w-5 h-5"></lucide-icon>
            <div *ngIf="!isSlimMode" class="sidebar-text text-white">
              {{ nav.menuName }}
            </div>
          </a>
        </div>
        }
        }

      </div>


      <div class="space-y-2" *ngIf="!missingOrganization">
        <div class="mb-2" *ngIf="hasRole('pavcon')">
          <div class="sidebar-header">
            <span class="header-text"> @if(isSlimMode) {Settings} @else {Admin Panel} </span>
          </div>
          <div class="header-divider"></div>
        </div>


        <a class="sidebar-item" [routerLink]="['/whats-new-settings']" *ngIf="!isSlimMode && hasRole('pavcon')"
          [ngClass]="{'active': isActive('/whats-new-settings'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, labelWhatsNewBBS)" (mouseleave)="hideSlimFlyout()">
          <lucide-icon name="Newspaper" class="text-white w-5 h-5"></lucide-icon>
          <div class="flex flex-col">
            <div class="text-white font-semibold text-sm">What's New</div>
            <div
              [ngClass]="{'text-gray-300': !isActive('/whats-new-settings'), 'text-white': isActive('/whats-new-settings')}"
              class="text-xs">Executive Orders Log</div>
          </div>
        </a>

        <a class="sidebar-item" [routerLink]="['/whats-new-settings']" *ngIf="isSlimMode && hasRole('pavcon')"
          [ngClass]="{'active': isActive('/whats-new-settings'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, labelWhatsNewBBS)" (mouseleave)="hideSlimFlyout()">
          <lucide-icon name="Newspaper" class="text-white w-5 h-5"></lucide-icon>
        </a>

        <a class="sidebar-item" [routerLink]="['/hearings-uploads']" *ngIf="!isSlimMode && hasRole('pavcon')"
          [ngClass]="{'active': isActive('/hearings-uploads'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, 'Hearings Upload')" (mouseleave)="hideSlimFlyout()">
          <lucide-icon name="Upload" class="text-white w-5 h-5"></lucide-icon>
          <div class="flex flex-col">
            <div class="text-white font-semibold text-sm">Hearings Upload</div>
            <div
              [ngClass]="{'text-gray-300': !isActive('/hearings-uploads'), 'text-white': isActive('/hearings-uploads')}"
              class="text-xs">Upload Hearings Excel Files</div>
          </div>
        </a>

        <a class="sidebar-item" [routerLink]="['/hearings-uploads']" *ngIf="isSlimMode && hasRole('pavcon')"
          [ngClass]="{'active': isActive('/hearings-uploads'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, 'Hearings Upload')" (mouseleave)="hideSlimFlyout()">
          <lucide-icon name="Upload" class="text-white w-5 h-5"></lucide-icon>
        </a>

        <a class="sidebar-item" [routerLink]="['/app-settings']" *ngIf="!isSlimMode && hasRole('pavcon')"
          [ngClass]="{'active': isActive('/app-settings'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, 'Admin Settings')" (mouseleave)="hideSlimFlyout()">
          <lucide-icon name="settings" class="text-white w-5 h-5"></lucide-icon>
          <div class="flex flex-col">
            <div class="text-white font-semibold text-sm">Admin Settings</div>
            <div [ngClass]="{'text-gray-300': !isActive('/app-settings'), 'text-white': isActive('/app-settings')}"
              class="text-xs">Features Settings and Preferences</div>
          </div>
        </a>

        <a class="sidebar-item" [routerLink]="['/app-settings']" *ngIf="isSlimMode && hasRole('pavcon')"
          [ngClass]="{'active': isActive('/app-settings'), 'flex items-center space-x-2': !isSlimMode, 'icon': isSlimMode}"
          (mouseenter)="showSlimFlyout($event, 'Admin Settings')" (mouseleave)="hideSlimFlyout()">
          <lucide-icon name="settings" class="text-white w-5 h-5"></lucide-icon>
        </a>
      </div>
    </nav>
  </div>
  <div *ngIf="isSlimMode && hoveredSlimLabel" class="sidebar-slim-flyout" [style.left.px]="flyoutLeft"
    [style.top.px]="flyoutTop">{{ hoveredSlimLabel }}</div>
</aside>